import React, { Component } from 'react';
import { connect } from 'react-redux';
import registrationTotal from '../../selectors/registrationTotal.selector';

class RegistrationTotal extends Component {
  render() {
    const { total } = this.props;
    return (
      <div className="Row Row-finalTotalRow">
        <input tabIndex="-1" className="Row-total Row-finalTotal" id="RTotal" data-tooltip="Registration Total" type="text" value={total} readOnly />
        <label tabIndex="-1" className="Row-finalTotalLabel" htmlFor="RTotal">REGISTRATION TOTAL</label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    total: registrationTotal(state),
  };
};

export default connect(mapStateToProps)(RegistrationTotal);



// WEBPACK FOOTER //
// ./src/containers/registration/RegistrationTotal.js